import { APP_BASE_HREF } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { LoadingData } from 'src/app/cevi-shared/cevi-http-interceptor';

@Injectable({
  providedIn: 'root'
})
export class LoginNavService {

  private  returnUrl: string;
  constructor( @Inject(APP_BASE_HREF) private baseHref:string, private loadingData :LoadingData ) { 
    this.returnUrl = '/dashboard';
  }

  public gotoAuthentication(provider:string, methode:string) {
    this.loadingData.incrSubj.next();

    if (this.returnUrl==='/login') {
      this.returnUrl = '/dashboard';
    }
    window.location.href = this.baseHref + `Api/Cobra/Login/Signin?provider=${provider}&methode=${methode}&returnUrl=${this.returnUrl}`;
  }

  public gotoLogout() {
    this.loadingData.incrSubj.next();
    window.location.href = this.baseHref + `Api/Cobra/Login/Logout`;
  }

  public setReturnUrl(returnUrl:string) {
    if (returnUrl==='/login') { return;}
    this.returnUrl = returnUrl;
  }

  public getReturnUrl(){
    return this.returnUrl;
  }
}
